import React from 'react';
import DesignerInfo from './DesignerInfo';
import FloatingCabinetDiagrams from '../diagrams/FloatingCabinetDiagrams';
import LiftingMechanismDiagram from '../diagrams/LiftingMechanismDiagram';
import FrameDiagram from '../diagrams/FrameDiagram';
import { useLanguage } from '../common/LanguageContext';
import '../../styles/layout.css';
import '../../styles/typography.css';

function DesignerSection() {
  const { translations } = useLanguage();

  return (
    <div className="container">
      <h1 className="heading-primary">{translations.designerPage.title}</h1>
      <div className="grid-layout">
        <DesignerInfo />
        <FloatingCabinetDiagrams />
        <LiftingMechanismDiagram />
        <FrameDiagram />
      </div>
    </div>
  );
}

export default DesignerSection;
